import {
  // Currencies,
  Notifications,
  SFXS,
} from '@orbital/games-frontend-library'
import floorFigure from '../../../helpers/floorFigure'
import { Currencies } from '../../../../../helpers/currency/getCurrencySymbol'
export default function HandleOperation(
  stake: string,
  operation: string,
  tofix: number,
  minbet: number,
  maxbet: number,
  handleStake: (s: string, name: string) => void,
  handleNotification: any,
  currency: string,
  audio: any,
  handleBaseStake: any,
) {
  //TODO make dynamic min
  const min = minbet.toString()
  let newStake = +stake

  switch (operation) {
    case '1/2':
      !audio.isSoundOff && SFXS.divideSFX.play()
      newStake < +min ? '' : (newStake /= 2)
      break
    case '2x':
      !audio.isSoundOff && SFXS.multiplySFX.play()
      newStake === 0
        ? (newStake = Number(min))
        : newStake > maxbet
        ? (newStake = maxbet)
        : (newStake *= 2)
      break
    default:
      break
  }
  if (newStake > maxbet) {
    newStake = Number(maxbet.toFixed(tofix))
    handleNotification(
      Notifications.maxStake +
        floorFigure(maxbet.toString(), tofix) +
        Currencies[currency].symbol,
    )
  }
  if (newStake < +min) {
    newStake = Number((+min).toFixed(tofix))
    handleNotification(
      Notifications.minStake +
        floorFigure(newStake.toString(), tofix) +
        Currencies[currency].symbol,
    )
  }
  return (
    handleStake(newStake.toFixed(tofix), 'STAKE'),
    handleBaseStake(newStake.toFixed(tofix))
  )
}
